import { createCustomMessage } from '../Utils/messageUtils'
import { MessageStrategy } from './messageStrategy'
import { helpMessageApi } from '../Services/searchRequest'

export class CustomMessageStrategy extends MessageStrategy {
  async send(componentName, sendMessage, payload) {
    if (!payload)
      return

    const customMessage = createCustomMessage(componentName, 'custom', { name: componentName, payload })
    sendMessage(customMessage)

    if (componentName === 'SearchComponent') {
      const helpQuestion = await helpMessageApi()

      if (helpQuestion) {
        const helpMessage = createCustomMessage('StaticMessages', 'custom', { name: 'StaticMessages', payload: { text: helpQuestion } })
        sendMessage(helpMessage)
      }
    }
  }
}